import TexsInGridController from './texs-in-grid.controller';
import Template from './texs-in-grid.html';

export default {
    bindings: {
		loading: '=',
		table: '=',
		pipe: '@'
	},
    controller: TexsInGridController,
    template: Template
};
